import { isEqual } from 'lodash';
import { GridRow } from '../types/types';

export type SlaveFetchCombo = {
  subsetId: string | null;
  parentRow: GridRow | null;
  activeFilters: unknown;
  activeSorting: unknown[] | null;
};

export const patchSlaveComboParentRow = (
  combo: SlaveFetchCombo,
  patch: GridRow
): SlaveFetchCombo =>
  combo.parentRow
    ? { ...combo, parentRow: { ...combo.parentRow, ...patch } }
    : combo;

// Skip a refetch only when this exact combo's data is already loaded. A combo recorded at dispatch whose data never landed (interrupted tab switch) has data == null here, so the caller re-drives instead of sticking on a spinner.
export const isSlaveComboLoaded = (
  lastCombo: SlaveFetchCombo,
  current: SlaveFetchCombo,
  data: unknown[] | null | undefined
): boolean =>
  data != null &&
  lastCombo.subsetId === current.subsetId &&
  isEqual(lastCombo.parentRow, current.parentRow) &&
  isEqual(lastCombo.activeFilters, current.activeFilters) &&
  isEqual(lastCombo.activeSorting, current.activeSorting);
